import { gql } from "graphql-tag";
import { externalLink, documentLink } from "~/app/prismic/prismic-fragments";

export const campaignSettingQuery = gql`
  query campaignSetting(
    $uid: String!
    $appUid: String!
    $lang: String = "en-in"
  ) {
    campaign_settings: campaign_settings1(uid: $uid, lang: $lang) {
      campaign_setting {
        saleTitle: sale_title
        enableCampaign: enable_campaign
        startTime: start_time
        endTime: end_time
        saleTileTitle: sale_tile_title
        saleTileTitleMobile: sale_tile_title_mobile
        pdpSaleTitle: pdp_sale_title
        pdpSaleBody: pdp_sale_body
        plpSaleBody: plp_sale_body
        pdpSalePrice: pdp_sale_price
        pdpTitleShowRRP: pdp_title_show_rrp
        saleColor: sale_color
        salePercentage: sale_percentage
        tags: tags
        campaignTitle: campaign_title
        enhancedUI: enhanced_ui
        showRRPText: show_rrp_text
        rrpText: rrp_text
        timerLabel: timer_label_text
        showTimerLabel: show_timer_label
        termsAndConditions: terms_and_conditions
        documentLink: document_link {
          ...externalLink
          ...documentLink
        }
      }
    }
    app_settings(uid: $appUid, lang: $lang) {
      badge_group {
        badgeTitle: badge_title
        badgeTag: badge_tag
        badgeColor: badge_color
      }
      tag_base_add_to_cart {
        tag_name
        button_text
        button_link {
          ...externalLink
          ...documentLink
        }
      }
      l2_plp_facet_mapping {
        facet_key
        facet_value
      }
      membership_image
    }
  }
  ${externalLink}
  ${documentLink}
`;

export const prismicHeaderQuery = gql`
  query prismicHeader($uid: String!, $lang: String = "en-in") {
    header(uid: $uid, lang: $lang) {
      site_title
      site_description
      site_logo
      mobile_banner
      mobile_banner_link {
        ...documentLink
      }
      information_banner {
        banner_text
      }
      information_banner_time_interval
      information_banner_color
      information_banner_text_color
      information_banner_font_size
      mega_menu_links {
        link_label
        link_color
        link {
          ...documentLink
        }
        second_level_menu {
          ... on Second_level_menu {
            body {
              ... on Second_level_menuBody2nd_level {
                type
              }
            }
          }
        }
      }
      header_icons {
        icon_name
        icon_link {
          ...documentLink
          ...externalLink
        }
      }
      meta_tags {
        name
        content
      }
    }
  }
  ${documentLink}
  ${externalLink}
`;

export const prismicFooterQuery = gql`
  query prismicFooter($uid: String!, $lang: String = "en-in") {
    footer(uid: $uid, lang: $lang) {
      social_icons_title
      social_icons {
        icon_name
        icon_link {
          ...documentLink
          ...externalLink
        }
      }
    }
  }
  ${documentLink}
  ${externalLink}
`;

export const prismicContactUsQuery = gql`
  query prismicContactUs($uid: String!, $lang: String = "en-in") {
    contact_us(uid: $uid, lang: $lang) {
      enquiry_email
      enquiry_phone_number
      enquiry_working_hours
    }
  }
`;

export const prismicOrganizationSettingsQuery = gql`
  query prismicOrganizationSettings($uid: String!, $lang: String = "en-in") {
    organization_settings(uid: $uid, lang: $lang) {
      organization_schema_description
      legal_name
      street_address
      address_locality
      address_region
      postal_code
      address_country
      latitude
      longitude
      organization_email
      general_telephone
      contact_point_type
      about_page_schema_description
      about_page_schema_uids
      opening_hours_rules {
        opens
        closes
        days
      }
    }
  }
`;
